import LandingPage from "@/componets/LandingLayout";
let pageSlug = "people-LP-V2";
const People = () => {
  return <LandingPage page={pageSlug} />;
};
People.hideLayout = true;
export default People;
